import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'accounts'
const verb = 'put'

export default class OspreyAccountsUpdate extends BaseAction {
    constructor(dataKey) {
        const id = '60bac4d5-17cd-482f-bd0e-ee16f0d425a5'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    update(account) {
        if (!account) {
            throw new Error('Missing account object')
        }

        this.path = `/${resource}/${account.id.value}`

        this.params = {
            account
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/accounts/accounts-update.js